<template>
  <div class="seeds-hidden type-g">
    <div class="groups groups-big h-100">
      <div class="round-titles round-titles-groups">
        <div class="round-title round-title-group">
          <h3>Group Stage</h3>
          <!-- <span></span> -->
        </div>
      </div>
      <div v-if="competition" v-for="(_group, j) in groups" class="group">
        <div class="group-name"><span>Group</span> {{ getLetter(j + 1) }}</div>

        <draggable
          v-if="
            matches
              .filter(match => {
                let checker = competition.stages.find(
                  stage =>
                    stage.isChosen && stage.category === $route.params.cat
                );
                if (checker) return match.stage._id === checker._id;
              })
              .every(match => !match._id)
          "
          :list="matchesByGroups[j]"
          :group="'group' + j"
          tag="ul"
          v-bind="dragOptions"
          @change="log"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group type="transition" name="flip-list">
            <li
              v-for="match in matchesByGroups[j]"
              class="game list-no-style"
              :class="{ 'game-completed': match.isFinished }"
              id="game-A-1"
              :key="match.home_team._id + match.away_team._id + match.round._id"
            >
              <div class="match-date-time">
                <span>{{
                  match.start_date
                    ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                    : ""
                }}</span>
                <span v-if="match.isCancelled" class="cancel">{{
                  $t("competition.cancelled")
                }}</span>
              </div>
              <div class="slot slot-top" :class="getSlot('top', match)" pid="1">
                <!-- <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div> -->
                <div class="slot-name">{{ match.home_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val">
                    {{ match.start_date }}
                  </div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>

              <div
                class="slot slot-bot"
                :class="getSlot('bottom', match)"
                pid="2"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div> -->
                <div class="slot-name">
                  {{ match.away_team && match.away_team.name }}
                </div>

                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val">
                    {{ match.start_date }}
                  </div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
            </li>
          </transition-group>
        </draggable>
        <div
          v-else
          v-for="match in matches.filter(match => {
            let neededStage = competition.stages.find(
              stage =>
                (stage.isChosen ? stage.isChosen : stage.isCurrent) &&
                stage.category.toString() === $route.params.cat.toString()
            );
            let homeCheck = match.home_team.group.find(
              ({ stage }) => neededStage && stage === neededStage._id
            );
            let awayCheck = match.away_team.group.find(
              ({ stage }) => neededStage && stage === neededStage._id
            );
            if (homeCheck && awayCheck)
              return homeCheck.index === j && awayCheck.index === j;
          })"
          class="game"
          :class="{ 'game-completed': match.isFinished }"
          id="game-A-1"
          @click="() => checkModal(match)"
        >
          <div class="match-date-time">
            <span>{{
              match.start_date
                ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                : ""
            }}</span>
            <span v-if="match.isCancelled" class="cancel">{{
              $t("competition.cancelled")
            }}</span>
          </div>
          <div class="slot slot-top" :class="getSlot('top', match)" pid="1">
            <!-- <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div> -->
            <div class="slot-name">{{ match.home_team.name }}</div>
            <div class="slot-score">
              <div class="slot-datetime-val slot-time-val"></div>
              <div class="slot-datetime-val slot-date-val"></div>
              <div class="slot-score-val">
                {{ getPoints(match.home_players, match, match.home_team) }}
              </div>
              <div class="slot-check">
                <div class="icon icon-check"></div>
              </div>
            </div>
          </div>

          <div class="slot slot-bot" :class="getSlot('bottom', match)" pid="2">
            <!-- <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div> -->
            <div class="slot-name">
              {{ match.away_team && match.away_team.name }}
            </div>

            <div class="slot-score">
              <div class="slot-datetime-val slot-time-val"></div>
              <div class="slot-datetime-val slot-date-val"></div>
              <div class="slot-score-val">
                {{ getPoints(match.away_players, match, match.away_team) }}
              </div>
              <div class="slot-check">
                <div class="icon icon-check"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isVisible"
      v-for="(bracket, i) in brackets"
      class="d-flex flex-column"
    >
      <h1 v-if="bracket.length">Bracket {{ i + 1 }}</h1>
      <div :class="getBracketClass(i)">
        <div class="winners mb-2 ">
          <div class="round round-8">
            <div
              v-if="
                bracket.filter(
                  match =>
                    match.placement === 'quarterfinal' &&
                    match.playoffStage >= 1
                ).length === 2
              "
              class="game"
              id="game-4"
            ></div>
            <div
              v-for="(match, i) in bracket.filter(
                match =>
                  match.placement === 'quarterfinal' && match.playoffStage >= 1
              )"
              :key="match._id"
              @click="() => openPlayoffModal(match, bracket)"
              class="game"
              :class="{ 'game-completed': match.isFinished }"
              id="game-4"
            >
              <div class="match-date-time">
                <span>{{
                  match.start_date
                    ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                    : ""
                }}</span>
                <span v-if="match.isCancelled" class="cancel">{{
                  $t("competition.cancelled")
                }}</span>
              </div>
              <div
                class="slot slot-top sz-med"
                :class="getSlot('top', match)"
                pid="1"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div> -->
                <div class="slot-name">{{ match.home_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.home_players, match, match.home_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>

              <div
                class="slot slot-bot sz-med"
                :class="getSlot('bottom', match)"
                pid="2"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div> -->
                <div class="slot-name">
                  {{ match.away_team && match.away_team.name }}
                </div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.away_players, match, match.away_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
            <div
              v-if="
                bracket.filter(
                  match =>
                    match.placement === 'quarterfinal' &&
                    match.playoffStage >= 1
                ).length === 2
              "
              class="game"
              id="game-4"
            ></div>
          </div>
          <div
            :class="
              bracket.filter(
                match =>
                  match.placement === 'semifinal' &&
                  match.playoffStage >= 1 &&
                  match.isUpperBracket
              ).length
                ? 'connectors-4'
                : ''
            "
            class="connectors"
          >
            <div class="connector"></div>
            <div class="connector connector-right"></div>
          </div>
          <div class="round round-4">
            <div
              v-for="(match, i) in bracket.filter(
                match =>
                  match.placement === 'semifinal' &&
                  match.playoffStage >= 0 &&
                  match.isUpperBracket
              )"
              :key="match._id"
              @click="() => openPlayoffModal(match, bracket)"
              class="game"
              :class="{ 'game-completed': match.isFinished }"
              id="game-4"
            >
              <div class="match-date-time">
                <span>{{
                  match.start_date
                    ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                    : ""
                }}</span>
                <span v-if="match.isCancelled" class="cancel">{{
                  $t("competition.cancelled")
                }}</span>
              </div>
              <div
                class="slot slot-top sz-med"
                :class="getSlot('top', match)"
                pid="1"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div> -->
                <div class="slot-name">{{ match.home_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.home_players, match, match.home_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>

              <div
                class="slot slot-bot sz-med"
                :class="getSlot('bottom', match)"
                pid="2"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div> -->
                <div class="slot-name">
                  {{ match.away_team && match.away_team.name }}
                </div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.away_players, match, match.away_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
          </div>
          <div
            class="connectors"
            :class="
              bracket.filter(
                match =>
                  match.placement === 'semifinal' && match.playoffStage >= 1
              ).length
                ? 'connectors-2'
                : ''
            "
          >
            <div class="connector"></div>
          </div>
          <div class="round round-2">
            <div
              v-for="(match, i) in bracket.filter(
                match => match.placement === 'final' && match.playoffStage >= 1
              )"
              :key="match._id"
              @click="() => openPlayoffModal(match, bracket)"
              class="game"
              :class="{ 'game-completed': match.isFinished }"
              id="game-4"
            >
              <div class="match-date-time">
                <span>{{
                  match.start_date
                    ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                    : ""
                }}</span>
                <span v-if="match.isCancelled" class="cancel">{{
                  $t("competition.cancelled")
                }}</span>
              </div>
              <div
                class="slot slot-top sz-med"
                :class="getSlot('top', match)"
                pid="1"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div> -->
                <div class="slot-name">{{ match.home_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.home_players, match, match.home_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>

              <div
                class="slot slot-bot sz-med"
                :class="getSlot('bottom', match)"
                pid="2"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div> -->
                <div class="slot-name">
                  {{ match.away_team && match.away_team.name }}
                </div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.away_players, match, match.away_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
          </div>
          <div class="round round-finals">
            <div class="game" id="game-00">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">6</div>
            </div>
            <div class="game" id="game-000">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">7 <span>(if necessary)</span></div>
            </div>
          </div>
          <div class="round-titles round-titles-winners">
            <div class="round-title round-title-1">
              <s>Winners </s>
              <span>Round 1</span>
              <span></span>
            </div>
            <div class="round-title round-title-2">
              <s>Winners </s>
              <span>Round 2</span>
              <span></span>
            </div>
            <div class="round-title round-title-3">
              <s>Winners </s>
              <span>Round 3</span>
              <span></span>
            </div>
            <div class="round-title round-title-quarter">
              <s>Winners </s>
              <span>Quarter-Finals</span>
              <span></span>
            </div>
            <div class="round-title round-title-semi">
              <s>Winners </s>
              <span>Semi-Finals</span>
              <span></span>
            </div>
            <div class="round-title round-title-finals">
              <s>Winners </s>
              <span>Finals</span>
              <span></span>
            </div>
            <div class="round-title round-title-grand">
              <span>Grand Finals</span>
              <span></span>
            </div>
            <div class="round-title-group-right">
              <div class="round-title round-title-semi">
                <span>Semi-Finals</span>
                <span></span>
              </div>
              <div class="round-title round-title-quarter">
                <span>Quarter-Finals</span>
                <span></span>
              </div>
              <div class="round-title round-title-3">
                <span>Round 3</span>
                <span></span>
              </div>
              <div class="round-title round-title-2">
                <span>Round 2</span>
                <span></span>
              </div>
              <div class="round-title round-title-1">
                <span>Round 1</span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="getLoserBracketClass(i)">
        <div class="winners mb-2">
          <div class="round round-4">
            <div
              v-for="(match, i) in bracket.filter(
                match =>
                  match.placement === 'quarterfinal' &&
                  match.playoffStage <= 0 &&
                  !match.isUpperBracket
              )"
              :key="match._id"
              @click="() => openPlayoffModal(match, bracket)"
              class="game"
              :class="{ 'game-completed': match.isFinished }"
              id="game-4"
            >
              <div class="match-date-time">
                <span>{{
                  match.start_date
                    ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                    : ""
                }}</span>
                <span v-if="match.isCancelled" class="cancel">{{
                  $t("competition.cancelled")
                }}</span>
              </div>
              <div
                class="slot slot-top sz-med"
                :class="getSlot('top', match)"
                pid="1"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div> -->
                <div class="slot-name">{{ match.home_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.home_players, match, match.home_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>

              <div
                class="slot slot-bot sz-med"
                :class="getSlot('bottom', match)"
                pid="2"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div> -->
                <div class="slot-name">
                  {{ match.away_team && match.away_team.name }}
                </div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.away_players, match, match.away_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
          </div>
          <div
            v-if="
              bracket.filter(
                match =>
                  (sizeOfBrackets === 6
                    ? match.placement === 'quarterfinal' ||
                      match.placement === 'semifinal'
                    : match.placement === 'semifinal') && !match.isUpperBracket
              ).length
            "
            class="connectors connectors-2"
          >
            <div class="connector"></div>
          </div>
          <div class="round round-2">
            <div
              v-for="(match, i) in bracket.filter(
                match =>
                  (sizeOfBrackets === 6
                    ? match.placement === 'quarterfinal' ||
                      match.placement === 'semifinal'
                    : match.placement === 'semifinal') && !match.isUpperBracket
              )"
              :key="match._id"
              @click="() => openPlayoffModal(match, bracket)"
              class="game"
              :class="{ 'game-completed': match.isFinished }"
              id="game-4"
            >
              <div class="match-date-time">
                <span>{{
                  match.start_date
                    ? $moment(match.start_date).format("DD-MM-YYYY HH:mm")
                    : ""
                }}</span>
                <span v-if="match.isCancelled" class="cancel">{{
                  $t("competition.cancelled")
                }}</span>
              </div>
              <div
                class="slot slot-top sz-med"
                :class="getSlot('top', match)"
                pid="1"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.home_team) }}</div> -->
                <div class="slot-name">{{ match.home_team.name }}</div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.home_players, match, match.home_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>

              <div
                class="slot slot-bot sz-med"
                :class="getSlot('bottom', match)"
                pid="2"
              >
                <!-- <div class="slot-seed">{{ getTeamNumber(match.away_team) }}</div> -->
                <div class="slot-name">
                  {{ match.away_team && match.away_team.name }}
                </div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val">
                    {{ getPoints(match.away_players, match, match.away_team) }}
                  </div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!brackets.length"
      v-for="(_, i) in Array.from(
        Array(Math.ceil(teams.length / sizeOfBrackets))
      )"
      class="d-flex flex-column"
    >
      <h1 v-if="Math.ceil(teams.length / sizeOfBrackets) > 0">
        Bracket {{ i + 1 }}
      </h1>
      <div :class="getBracketClass(null)">
        <div class="winners mb-2 ">
          <div class="round round-8">
            <div class="game fake" id="game-3">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
            <div class="game fake" id="game-4">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
            <div class="game game-right fake" id="game-5">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
            <div class="game game-right fake" id="game-6">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number"></div>
            </div>
          </div>
          <div class="connectors connectors-4">
            <div class="connector"></div>
            <div class="connector connector-right"></div>
          </div>
          <div class="round round-4">
            <div class="game fake" id="game-1">
              <div class="slot slot-top slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">1</div>
            </div>
            <div class="game game-right fake" id="game-2">
              <div class="slot slot-top slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">2</div>
            </div>
          </div>
          <div class="connectors connectors-2">
            <div class="connector"></div>
          </div>
          <div class="round round-2">
            <div class="game fake" id="game-0">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">4</div>
            </div>
          </div>
        </div>
      </div>
      <div :class="getLoserBracketClass(null)">
        <div class="winners mb-2">
          <div class="round round-4">
            <div class="game fake" id="game-1">
              <div class="slot slot-top slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">1</div>
            </div>
            <div class="game game-right fake" id="game-2">
              <div class="slot slot-top slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot slot-instruct sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">2</div>
            </div>
          </div>
          <div class="connectors connectors-2">
            <div class="connector"></div>
          </div>
          <div class="round round-2">
            <div class="game fake" id="game-0">
              <div class="slot slot-top sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-date-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="slot slot-bot sz-med" pid="">
                <div class="slot-seed"></div>
                <div class="slot-name"></div>
                <div class="slot-score">
                  <div class="slot-datetime-val slot-time-val"></div>
                  <div class="slot-datetime-val slot-loct-val"></div>
                  <div class="slot-score-val"></div>
                  <div class="slot-check">
                    <div class="icon icon-check"></div>
                  </div>
                </div>
              </div>
              <div class="game-number">4</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bracketsMixin from "./bracketsMixin";
import draggable from "vuedraggable";

export default {
  name: "bracketGroup",
  components: { draggable },
  data() {
    return bracketsMixin;
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    log(e) {
      console.log(e);
    },
    getBracketClass(iterator) {
      let divisor = 0;
      if (!iterator) {
        divisor = this.sizeOfBrackets;
      } else {
        const fullIterations = Math.floor(
          this.teams.length / this.sizeOfBrackets
        );
        const remainder = this.teams.length % this.sizeOfBrackets;
        if (iterator < fullIterations) {
          divisor = this.sizeOfBrackets;
        } else if (iterator === fullIterations) {
          divisor = remainder;
        }
      }
      if (divisor) {
        let className =
          "count-" +
          divisor +
          " bracket-" +
          this.closestPowerOfTwo(divisor, "upper").toString();
        return className;
      } else {
        return "d-none";
      }
    },
    getLoserBracketClass(i) {
      let divisor = 0;
      if (!i) {
        divisor = this.sizeOfBrackets;
      } else {
        const fullIterations = Math.floor(
          this.teams.length / this.sizeOfBrackets
        );
        const remainder = this.teams.length % this.sizeOfBrackets;

        if (i < fullIterations) {
          divisor = this.sizeOfBrackets;
        } else if (i === fullIterations) {
          divisor = remainder;
        }
      }
      if (divisor) {
        if (this.closestPowerOfTwo(divisor / 2, "lower") === 1) {
          return "d-none";
        }
        let className =
          "count-" +
          this.closestPowerOfTwo(divisor / 2, "lower").toString() +
          " bracket-" +
          this.closestPowerOfTwo(divisor / 2, "lower").toString();
        return className;
      } else {
        return "d-none";
      }
    },
    getTeamInGroup(match, group) {
      const teams = group.some(
        team =>
          team._id === match.home_team._id || team._id === match.away_team._id
      );
      return teams;
    }
  },
  async created() {
    if (this.isVisible) {
      await this.getCurrentTeams();
      this.formGroups();
      this.updateLocalGroups();
      await this.getCurrentTeams();
      this.formGroups();
      await this.generateRounds();
      await this.generateRoundRobinSchedule();
      this.formTwoDimensionalMatchArray();
    } else {
      await this.getExtendedCurrentTeams();
      this.formTwoDimensionalMatchArray();
      if (this.groupStageFinished) {
        await this.getRealPlayoffMatches();
        if (!this.playoffs.length) {
          const bracketsForLoop = this.addPlayoffMatchesBySOB();
          for (let j = 0; j < bracketsForLoop.length; j++) {
            const element = bracketsForLoop[j];
            this.createFirstStageMatches(element, j);
          }
          await this.addPlayoffsToDB();
          await this.getRealPlayoffMatches();
        }

        for (let j = 0; j < this.brackets.length; j++) {
          const element = this.brackets[j];
          if (
            !element.filter(match => !match.isFinished && match.away_team)
              .length &&
            !element.filter(
              match => match.placement === "final" && match.isFinished
            ).length
          ) {
            if (this.sizeOfBrackets > 4) {
              if (element.filter(match => match.isFinished).length <= 4) {
                this.createFurtherMatches(
                  element.filter(match => match.isFinished)
                );
              } else {
                this.createFurtherMatches(
                  element.filter(
                    match =>
                      match.placement !== "quarterfinal" ||
                      !match.isUpperBracket
                  )
                );
              }
            } else {
              this.createFurtherMatches(
                element.filter(match => match.isFinished)
              );
            }
          }
        }
        if (
          this.playoffs.filter(match => !match.isFinished && !match._id).length
        )
          await this.addPlayoffsToDB();
        await this.getRealPlayoffMatches();
        if (!this.playoffs.filter(match => !match.isFinished).length) {
          // this.getFinalStandings();
          this.listedTeams = this.sortByStageStats(
            JSON.parse(JSON.stringify([...this.teamsTotallySortedArray])),
            true
          );
          this.showFinalStandings = true;
        }
      }
      this.category = this.$route.params.cat;
      if (
        this.competition.stages.find(
          stage =>
            stage.isChosen &&
            stage.isCurrent &&
            stage.category === this.category
        )
      )
        await this.checkTeamIntegrity();
      this.checkFinishCompetition();
      this.turnOnInbetweenStagesVisibility();
    }
  },
  async mounted() {
    console.log(this.getWCMatchQty(4));
    console.log(this.getSEMatchQty(2));
  }
};
</script>

<style scoped>
@import "./brackets.css";
.flip-list-move {
  transition: transform 0.5s;
}
.list-no-style {
  list-style-type: none;
}
ul {
  padding: 0;
  margin: 0;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.game.fake {
  height: 55px !important;
}

.match-date-time {
  color: #ffef00;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 18px;
  padding: 0 10px;
  font-size: 12px;
  text-shadow: 1px 1px #000;
}

.match-date-time span.cancel {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/brackets/Group.vue